import { render, staticRenderFns } from "./PowerScanPageFooter.vue?vue&type=template&id=4f3d5c72&"
import script from "./PowerScanPageFooter.vue?vue&type=script&lang=js&"
export * from "./PowerScanPageFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports